export const handleInitValue = (data, config) => {
  return config?.filter((val) => val?.value == data)[0]?.value;
};

export const handleRoleId = (data, config) => {
  return config?.filter((val) => val?.value == data)[0]?.roleId;
};
